import { render } from "./LoginRegisterSwitcher.vue?vue&type=template&id=e29055b2&scoped=true&lang=pug"
import script from "./LoginRegisterSwitcher.vue?vue&type=script&lang=js"
export * from "./LoginRegisterSwitcher.vue?vue&type=script&lang=js"

import "./LoginRegisterSwitcher.vue?vue&type=style&index=0&id=e29055b2&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29055b2"]])

export default __exports__